"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationField = exports.IntegrationFieldConfig = exports.IntegrationFieldType = void 0;
const tslib_1 = require("tslib");
const t = (0, tslib_1.__importStar)(require("io-ts"));
const validators_1 = require("../../../validators");
exports.IntegrationFieldType = "IntegrationFields";
exports.IntegrationFieldConfig = t.exact(t.partial({
    label: validators_1.StringOrNull,
    placeholder: t.string,
    catalog: t.string,
}));
exports.IntegrationField = t.exact(t.intersection([
    t.type({
        type: t.literal(exports.IntegrationFieldType),
    }),
    t.partial({
        fieldset: validators_1.StringOrNull,
        config: exports.IntegrationFieldConfig,
    }),
]));
